import "./layout.scss";
import {
    SidebarProvider,
} from "@/components/ui/sidebar.tsx";
import {Outlet} from 'react-router-dom';
import SideMenuComponent from "@/screens/app/layout/side-menu/SideMenuComponent.tsx";
import AppHeaderComponent from "@/screens/app/layout/app-header/AppHeaderComponent.tsx";
import AppVersionComponent from "@/components/common-components/app-version/AppVersionComponent.tsx";

const AppLayout = () => {
    return (
        <div className="app-screen home-screen">
            <SidebarProvider>
                <AppHeaderComponent/>
                <div className="flex w-full app-content-wrapper">
                    <SideMenuComponent/>
                    <Outlet/>
                </div>
                <AppVersionComponent/>
            </SidebarProvider>
        </div>
    );
};

export default AppLayout;
